import _extends from 'babel-runtime/helpers/extends';

export default {
  data: function data() {
    return {
      model: {
        name: ''
      },
      form: {
        name: {
          prop: 'name',
          label: '名称',
          rules: [{
            required: true,
            message: '名称是必填项'
          }]
        }
      }
    };
  },


  computed: {
    dialogAttrs: function dialogAttrs() {
      return _extends({
        appendToBody: true
      }, this.$attrs, {
        showClose: false
      });
    }
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.$refs.form.validate(function (valid) {
        if (valid) _this.$emit('submit', _this.model);
      });
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
};